var React = require('react');

function Whatsapp (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"none","d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9","key":1}),React.createElement("path",{"d":"M9 10a0.5 .5 0 0 0 1 0v-1a0.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a0.5 .5 0 0 0 0 -1h-1a0.5 .5 0 0 0 0 1","key":2})]);
}

Whatsapp.defaultProps = {"className":"icon icon-tabler icon-tabler-brand-whatsapp","width":"24","height":"24","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","fill":"none","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Whatsapp;

Whatsapp.default = Whatsapp;
